import styled, { css } from 'styled-components'
import Colors from '../../constants/colors'
import { BlogThreshold as Threshold } from '../../constants/theme'

export const BlogHeaderContainer = styled.section`
  align-self: stretch;
  margin-bottom: 15px;
  padding: 0 20px;
  padding-top: 127px;
  padding-bottom: 143px;
  background: #000 url('/static/images/white-gap-horizontal.png') no-repeat center bottom;
  background-size: contain;
  text-align: center;
  @media (max-width: ${Threshold.tablet}) {
    margin-top: -45px;
    padding-bottom: 111px;
  }
  @media (max-width: ${Threshold.phone}) {
    padding-top: 40px;
    padding-bottom: 60px;
    img {
      max-width: 129px;
    }
  }
`

export const BlogMenu = styled.nav`
  margin: 0 auto;
  margin-top: 73px;
  max-width: 1186px;
  display: flex;
  justify-content: center;
  
  @media (max-width: ${Threshold.tablet}) {
    margin-top: 53px;
    flex-wrap: wrap;
  }
  
  @media (max-width: ${Threshold.phone}) {
    margin-top: 29px;
    margin-left: -10px;
    margin-right: -10px;
  }
`

export const BlogMenuItem = styled.a`
  min-width: 118px;
  margin: 14px 30px;
  transition-duration: 0.2s;
  text-decoration: none;
  text-transform: uppercase;
  font-family: StolzlMedium, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 2px;
  color: #fff;
  :visited {
    color: #fff;
  }
  :hover {
    color: ${Colors.primaryHover};
  }
  :active {
    opacity: 0.8;
  }
  ${props => props.selected
  && css`
      color: ${Colors.primary};
      font-family: StolzlMedium, serif;
      letter-spacing: 1px;
      @media (max-width: 1200px) {
        letter-spacing: 0;
      }
      &:visited {
        color: ${Colors.primary};
      }
    `}
  
  @media (max-width: ${Threshold.phone}) {
    min-width: 68px;
    margin: 14px 10px;
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 1.2px;
  }
`
